import { useContext, createContext } from 'react';

import type { PointPayIdentity } from './session-identity';

export const PointPaySessionContext = createContext<PointPayIdentity | null>(null);
export const usePointPaySession = () => useContext(PointPaySessionContext);
